import React from 'react';
import { SectionFade } from './ui/SectionFade';
import { XIcon } from 'lucide-react';
const attempts = [{
  title: 'Contar calorías',
  desc: 'Ignora que 100 calorías de brócoli no impactan igual que 100 calorías de fructosa líquida.'
}, {
  title: 'Leer solo la tabla nutricional',
  desc: "Te fijas en los gramos, pero no en los ingredientes químicos que disparan tu insulina aunque digan '0g azúcar'."
}, {
  title: 'Usar apps de escaneo',
  desc: 'Te dan una nota del 1 al 10 sin enseñarte a identificar los nombres falsos que la industria inventa cada mes.'
}, {
  title: "Confiar en el sello 'Orgánico'",
  desc: 'Un refresco orgánico sigue siendo una bomba de azúcar para tu hígado.'
}];
export function FailedAttempts() {
  return <section className="py-24 px-4 bg-brand-gray" data-id="element-26">
      <div className="max-w-5xl mx-auto" data-id="element-27">
        <SectionFade data-id="element-28">
          <h2 className="font-bebas text-5xl md:text-7xl text-center mb-16 tracking-tight" data-id="element-29">
            LO QUE HAS INTENTADO Y{' '}
            <span className="text-red-500" data-id="element-30">POR QUÉ FALLÓ:</span>
          </h2>
        </SectionFade>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-31">
          {attempts.map((item, index) => <SectionFade key={index} delay={index * 0.1} data-id="element-32">
              <div className="bg-brand-black p-8 rounded-xl border border-white/5 h-full relative overflow-hidden group hover:border-red-500/30 transition-colors" data-id="element-33">
                <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-34">
                  <XIcon size={120} className="text-red-500" data-id="element-35" />
                </div>
                <div className="relative z-10" data-id="element-36">
                  <div className="flex items-center gap-4 mb-4" data-id="element-37">
                    <div className="bg-red-500/20 p-2 rounded-full" data-id="element-38">
                      <XIcon className="text-red-500" size={24} data-id="element-39" />
                    </div>
                    <h3 className="font-bebas text-3xl tracking-wide line-through decoration-red-500/50 decoration-2" data-id="element-40">
                      {item.title}
                    </h3>
                  </div>
                  <p className="text-gray-400 font-inter leading-relaxed" data-id="element-41">
                    {item.desc}
                  </p>
                </div>
              </div>
            </SectionFade>)}
        </div>
      </div>
    </section>;
}